import React, { useState } from 'react';

import IconEdit from '../../assets/images/common/icon-edit.svg';

import { MasterInquireApiResponse } from '../../types/api/MasterInquireApiType';
import { InputType, CI_INPUT_MODE, CustomerInformationInputType } from '../../types/common/CustomerInformationType';

import { CustomerInformationInput } from '../../pages/CustomerInformation/CustomerInformationInput';

type ConfirmationCustomerInformationProps = {
    cIInput: CustomerInformationInputType;
    setCIInput: (value: CustomerInformationInputType) => void;
    errerMessages: Array<string>;
    masterInquireData: MasterInquireApiResponse;
};

export const ConfirmationCustomerInformation: React.FC<ConfirmationCustomerInformationProps> = ({
    cIInput,
    setCIInput,
    errerMessages,
    masterInquireData,
}) => {
    const [inputType, setInputType] = useState<InputType>(CI_INPUT_MODE.READ);
    return (
        <div className='container'>
            <div className='columns form-item_area'>
                <div className='column is-12'>
                    <div className='column-header'>
                        <h2>個人情報のご入力</h2>
                        <button
                            className='button is-small editlist'
                            onClick={() => setInputType(CI_INPUT_MODE.RE_WRITE)}
                            disabled={inputType !== CI_INPUT_MODE.READ}
                        >
                            内容を修正する
                            <span className='icon is-small is-right'>
                                <img src={IconEdit} alt='' />
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <CustomerInformationInput
                dataInput={inputType}
                cIInput={cIInput}
                setCIInput={setCIInput}
                errorMessages={errerMessages}
                masterInquire={masterInquireData}
            />
        </div>
    );
};
